module.exports = __webpack_public_path__ + "static/media/center_02.9f15a4b4.jpg";